<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Part" active>

                                <b-row v-if="hasFailedDataPart">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPart.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partsFailed" :fields="fieldsPart" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPart" :sort-desc.sync="sortDescPart" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<!-- <template #cell(stockLevelCustomer)="row">
													{{ Number(row.item.stockLevelCustomer).toLocaleString() }}
												</template> -->
												<template #cell(standarPackagingQty)="row">
													{{ Number(row.item.standarPackagingQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPart.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="parts" :fields="fieldsPart" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPart" :sort-desc.sync="sortDescPart" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<!-- <template #cell(stockLevelCustomer)="row">
													{{ Number(row.item.stockLevelCustomer).toLocaleString() }}
												</template> -->
												<template #cell(standarPackagingQty)="row">
													{{ Number(row.item.standarPackagingQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Part Detail" active>

                                <b-row v-if="hasFailedDataPartDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPartDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partDetailsFailed" :fields="fieldsPartDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartDetail" :sort-desc.sync="sortDescPartDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPartDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partDetails" :fields="fieldsPartDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartDetail" :sort-desc.sync="sortDescPartDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import Part from '@/models/Part/Part';
import PartList from '@/models/Part/PartList';
import PartFilter from '@/filters/Part/PartFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsPart: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Number", key: 'partNumber', sortable: false},
				{"class" : "th-status", "label" : "Part Name", key: 'partName', sortable: false},
				{"class" : "th-status", "label" : "Part Specification", key: 'partSpecification', sortable: false},
				{"class" : "th-status", "label" : "Customer", key: 'customerCode', sortable: false},
				{"class" : "th-status", "label" : "Direct Delivery ?", key: 'isDirectDelivery', sortable: false},
				// {"class" : "th-status", "label" : "Stock Level Customer (Day)", key: 'stockLevelCustomer', sortable: false},
				{"class" : "th-status", "label" : "Part Classification", key: 'partClassificationCode', sortable: false},
				{"class" : "th-status", "label" : "Packaging Type", key: 'packagingTypeCode', sortable: false},
				{"class" : "th-status", "label" : "Uom", key: 'uomCode', sortable: false},
				{"class" : "th-status", "label" : "Standard Packaging Qty", key: 'standarPackagingQty', sortable: false},
				//{"class" : "th-status", "label" : "Vendor Subcontract", key: 'vendorSubcontractCode', sortable: false},
				{"class" : "th-status", "label" : "Need Repacking ?", key: 'isNeedRepacking', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPartDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Supplier Code", key: 'supplierCodeCode', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			parts : [],
			partsFailed: [],
			partId : '',
			sortByPart: '',
			sortDescPart: '',
			hasFailedDataPart: false,
			totalFailedPart: 0,
			totalSucceedPart: 0,
			partDetails : [],
			partDetailsFailed: [],
			partDetailId : '',
			sortByPartDetail: '',
			sortDescPartDetail: '',
			hasFailedDataPartDetail: false,
			totalFailedPartDetail: 0,
			totalSucceedPartDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('part/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('part/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getPartForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getPartForUpload : async function() {
			let _this = this;
			this.$http.get('part/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.parts = [];
_this.partDetails = [];


					if (response != null) {
						let result = response.data;
						_this.parts = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedPart = _this.parts.length;

						_this.partsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataPart = true;
						_this.totalFailedPart = 0;
						if(_this.partsFailed == undefined || _this.partsFailed.length === 0) _this.hasFailedDataPart = false;
						if(_this.hasFailedDataPart) _this.totalFailedPart = _this.partsFailed.length;
						_this.partDetails = [];
						_this.partDetailsFailed = [];
						_this.hasFailedDataPartDetail = true;
						_this.totalSucceedPartDetail = 0;
						result.forEach(function(element) {
							_this.partDetails.push(...element.partDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPartDetail = _this.partDetails.length;

							_this.partDetailsFailed.push(...element.partDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.partDetailsFailed == undefined || _this.partDetailsFailed.length === 0) _this.hasFailedDataPartDetail = false;
							if(_this.hasFailedDataPartDetail) _this.totalFailedPartDetail = _this.partDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'part/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'Part.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterPart = new PartFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
